/*过滤千分位*/
export function numChange (value) {
  if (!value || value == '-') return value
  if (value){
    return (Number(value)).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
}

/*过滤千分位*/
export function strChange (value) {
  if (!value || value == '-') return value
  return (Number(value).toString().replace(/(\d)(?=(?:\d{3})+$)/g,'$1,'))
}